import { CHAT_TRIGGER_NODE_TYPE, EXECUTE_WORKFLOW_TRIGGER_NODE_TYPE, MANUAL_TRIGGER_NODE_TYPES, MCP_TRIGGER_NODE_TYPE, } from './constants';
import { toExecutionContextEstablishmentHookParameter } from './execution-context-establishment-hooks';
const NO_IDENTITY = {
    providesN8nIdentity: false,
    providesExternalIdentity: false,
};
/** Whether a trigger's parameters declare at least one context establishment hook. */
function hasContextEstablishmentHook(parameters) {
    const hookParams = toExecutionContextEstablishmentHookParameter(parameters);
    return (hookParams !== null &&
        hookParams.success &&
        hookParams.data.contextEstablishmentHooks.hooks.length > 0);
}
/**
 * Classifies a single trigger node by the identity it can establish at runtime.
 *
 * Shared by the backend publish-time validation (`WorkflowValidationService`) and
 * the editor's trigger-compatibility warning so the two can't drift. Keep it in
 * sync with how the engine establishes identity (`execution-context.ts`,
 * manual/parent inheritance) and the resolvers' identifiers (e.g. `N8NIdentifier`):
 * when a new trigger or identity source is added there, reflect it here too.
 */
export function classifyTriggerIdentity(nodeType, parameters) {
    // Sub-workflows inherit identity from the parent; Chat Hub and MCP-over-n8nOAuth2
    // inject it. All provide both identity families.
    const isSubWorkflowTrigger = nodeType === EXECUTE_WORKFLOW_TRIGGER_NODE_TYPE;
    const isChatHubTrigger = nodeType === CHAT_TRIGGER_NODE_TYPE && parameters?.availableInChat === true;
    const isMcpTrigger = nodeType === MCP_TRIGGER_NODE_TYPE && parameters?.authentication === 'n8nOAuth2';
    if (isSubWorkflowTrigger || isChatHubTrigger || isMcpTrigger) {
        return { providesN8nIdentity: true, providesExternalIdentity: true };
    }
    // Manual/chat/MCP triggers run with the n8n user identity.
    if (MANUAL_TRIGGER_NODE_TYPES.includes(nodeType)) {
        return { providesN8nIdentity: true, providesExternalIdentity: false };
    }
    // Any other trigger with a context establishment hook provides an external identity.
    if (hasContextEstablishmentHook(parameters)) {
        return { providesN8nIdentity: false, providesExternalIdentity: true };
    }
    return NO_IDENTITY;
}
//# sourceMappingURL=trigger-identity.js.map